import taskTemplateApi from '../templates/sagas/api';
import taskApi from './api';
import tasksToasts from './toasts';

export default [
  taskApi(),
  taskTemplateApi(),
  tasksToasts(),
];
